import { render, staticRenderFns } from "./dbList.vue?vue&type=template&id=41734c72&scoped=true"
import script from "./dbList.vue?vue&type=script&lang=js"
export * from "./dbList.vue?vue&type=script&lang=js"
import style0 from "./dbList.vue?vue&type=style&index=0&id=41734c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41734c72",
  null
  
)

export default component.exports